import { useEffect, useState } from "react";
import {

  Box,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import Select from "react-select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { axiosInstance } from "../../../utility/apiInstance";
import toast from "react-hot-toast";
// ── Shared react-select styling (portalled so it never clips inside the modal) ──
const rsStyles: any = {
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: "#fff",
    border: `1px solid ${state.isFocused ? "#f5a623" : "#e4e7ec"}`,
    borderRadius: 8,
    minHeight: 44,
    boxShadow: state.isFocused ? "0 0 0 3px #fff3dc" : "none",
    "&:hover": { border: `1px solid ${state.isFocused ? "#f5a623" : "#c2cad6"}` },
  }),
  placeholder: (base: any) => ({ ...base, color: "#9aa2af", fontSize: 13.5 }),
  multiValue: (base: any) => ({ ...base, backgroundColor: "#f1f3f6", borderRadius: 6 }),
  multiValueLabel: (base: any) => ({ ...base, color: "#1f2430", fontWeight: 600, fontSize: 12 }),
  option: (base: any, state: any) => ({
    ...base,
    backgroundColor: state.isSelected ? "#fff3dc" : state.isFocused ? "#f6f7f9" : "#fff",
    color: "#1f2430",
    fontSize: 13.5,
    cursor: "pointer",
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 20000 }),
};

// ── Small presentational helpers ──
const labelStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: 13,
  fontWeight: 700,
  color: "#1f2430",
  marginBottom: 8,
};
const errStyle: React.CSSProperties = { color: "#d92d20", fontSize: 11.5, marginTop: 6 };


const OceanSubscriptionForm = ({
  setmodalPopup,
  subscriptionFormData,
  manageContactList,
  setSubscriptionFormData,
  type,
  subscriptionList,
  whatsappGroupList,
  loading,
  addSubscription,
  editable,
  editData,
  getAllMileStone,
}: any) => {

  const [errors, setErrors] = useState<any>({});
  // Inline "select AWB first" warning — replaces the toast/popup
  const [awbWarning, setAwbWarning] = useState(false);


  useEffect(() => {
    if (Object.keys(editData)?.length === 0) {
      manageTemplate();
    }
    getContactList("");
    if (type === "Awb") {
      getAllAirBill();
    }
    whatsappGroup();
    getAllMasterCustomerOrganization()
  }, []);


  // Clear stale validation messages when the user changes any selection
  useEffect(() => {
    setErrors({});
  }, [
    subscriptionFormData.whatsApp,
    subscriptionFormData.emails,
    subscriptionFormData.whatsAppgroups,
    subscriptionFormData.whatsAppMilestones,
    subscriptionFormData.emailMilestones,
    subscriptionFormData.whatsappGroupMilestones,
  ]);

  // Once an AWB is chosen, drop the inline warning
  useEffect(() => {
    if (subscriptionFormData?.awbs && subscriptionFormData.awbs.length !== 0) {
      setAwbWarning(false);
    }
  }, [subscriptionFormData.awbs]);

  const getContactList = async (masterOrganizationId: string) => {
    try {
      let response = await axiosInstance.get("/api/v1/contact");
      if (masterOrganizationId) {
        response = await axiosInstance.get(`/api/v1/contact/${masterOrganizationId}`);
      }
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          manageContactList: response?.data?.data,
        };
      });
    } catch (err: any) {

      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          manageContactList: []
        };
      });
    }
  };
  const getAllMasterCustomerOrganization = async () => {
    try {
      let { data } = await axiosInstance.get("/api/v1/master-contact-organization");

      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          masterContactOrgnization: data?.data,
        };
      });
    } catch (err: any) {
      setSubscriptionFormData((prev: any) => (
        {
          ...prev,
          masterContactOrgnization: []
        }
      ))
    }
  };



  const getAllAirBill = async () => {
    try {
      let response = await axiosInstance.get(
        "/api/v1/ocean/added-tracking-numbers"
      );
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: response?.data?.data,
        };
      });
    } catch (err) {
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          subscriptionList: [],
        };
      });
    }
  };

  const manageTemplate = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/ocean/template");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          templateList: response?.data?.data,
        };
      });
    } catch (err) {
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          templateList: [],
        };
      });

    }
  };

  const whatsappGroup = async () => {
    try {
      let response = await axiosInstance.get("/api/v1/whatsapp-group");
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          whatsappGroupList: response?.data?.data,
        };
      });
    } catch (error) {
      setSubscriptionFormData((prev: any) => {
        return {
          ...prev,
          whatsappGroupList: [],
        };
      });
    }
  };

  // ── AWB presence (mirrors the submit button's disabled check) ──
  const hasAwb = !(!subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0);

  // ── Guard: block milestone popup until a tracking number is chosen ──
  const openMilestone = (mileStoneType: string) => {
    if (type === "Awb" && !hasAwb) {
      setAwbWarning(true); // inline message instead of toast/popup
      return;
    }
    setAwbWarning(false);
    setmodalPopup((prev: any) => ({
      ...prev,
      subcriptionPopup: false,
      mileStonePopup: true,
    }));
    setSubscriptionFormData((prev: any) => ({ ...prev, mileStoneType }));
  };

  // ── Validation: each channel needs recipients AND milestones together ──
  const validate = () => {
    const next: any = {};

    const waLen = subscriptionFormData.whatsApp?.length || 0;
    const waMLen =
      subscriptionFormData.whatsAppMilestones?.length || 0;

    const emLen = subscriptionFormData.emails?.length || 0;
    const emMLen =
      subscriptionFormData.emailMilestones?.length || 0;

    const grLen = subscriptionFormData.whatsAppgroups?.length || 0;
    const grMLen =
      subscriptionFormData.whatsappGroupMilestones?.length || 0;

    if (waLen > 0 && waMLen === 0) {
      next.whatsApp = "Select at least one WhatsApp milestone";
    }

    if (waMLen > 0 && waLen === 0) {
      next.whatsApp = "Select at least one WhatsApp recipient";
    }

    if (emLen > 0 && emMLen === 0) {
      next.emails = "Select at least one email milestone";
    }

    if (emMLen > 0 && emLen === 0) {
      next.emails = "Select at least one email recipient";
    }

    if (grLen > 0 && grMLen === 0) {
      next.groups = "Select at least one group milestone";
    }

    if (grMLen > 0 && grLen === 0) {
      next.groups = "Select at least one WhatsApp group";
    }

    if (waLen === 0 && emLen === 0 && grLen === 0) {
      next.channel = "Select recipients for at least one channel";
    }

    setErrors(next);

    if (Object.keys(next).length) {
      toast.error(Object.values(next)[0] as string);
      return false;
    }

    return true;
  };

  const handleSubmitClick = () => {
    if (!validate()) return;
    addSubscription();
  };

  // Reusable milestone trigger (keeps original onClick logic via openMilestone)
  const MilestoneTrigger = ({ mileStoneType, count }: { mileStoneType: string; count: number }) => {
    const total = (subscriptionFormData?.milestoneList || []).length;
    return (
      <div
        onClick={() => openMilestone(mileStoneType)}
        style={{
          marginTop: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 12px",
          border: "1px dashed #e4e7ec",
          borderRadius: 8,
          cursor: "pointer",
          background: "#fafbfc",
          transition: "border-color .15s, background .15s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = "#f5a623";
          e.currentTarget.style.background = "#fff8ec";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = "#e4e7ec";
          e.currentTarget.style.background = "#fafbfc";
        }}
      >
        <span style={{ fontSize: 12.5, color: "#5b6472", fontWeight: 600 }}>
          🏁 Include / Exclude milestones
        </span>
        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {count > 0 && (
            <span
              style={{
                fontSize: 11.5,
                fontWeight: 700,
                color: "#92650d",
                background: "#fff3dc",
                borderRadius: 999,
                padding: "2px 9px",
              }}
            >
              {count} / {total} selected
            </span>
          )}
          <IconButton size="small" onClick={(e) => { e.stopPropagation(); openMilestone(mileStoneType); }}>
            <KeyboardArrowDownIcon fontSize="small" />
          </IconButton>
        </span>
      </div>
    );
  };


  return (
    <Box
      className="modalTracking"
      sx={{ width: "100%", maxWidth: "100%", margin: "auto", padding: 0 }}
    >
      {Object.keys(editData)?.length === 0 && (
        <div className="mb-3">
          <div style={labelStyle}>📋 Choose a Template</div>
          <Select
            name="templateName"
            options={subscriptionFormData?.templateList?.map((item: any) => ({
              label: item?.templateName,
              value: item?._id,
            }))}
            placeholder="Choose Template"
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            value={subscriptionFormData?.templateName}
            onChange={(option: any) => {
              let findEmailMileStone = subscriptionFormData.templateList?.find(
                (item: any) => item?._id === option?.value
              );
              setSubscriptionFormData((prev: any) => {
                return {
                  ...prev,
                  whatsApp: findEmailMileStone?.waContacts?.map((item: any) => ({
                    label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.masterContactOrganization?.name})`,
                    value: item._id,
                  })),
                  emails: findEmailMileStone?.emailContacts.map((item: any) => ({
                    label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.masterContactOrganization?.name})`,
                    value: item._id,
                  })),
                  whatsAppgroups: findEmailMileStone?.whatsappGroups?.map((item: any) => ({
                    label: `${item?.name}`,
                    value: item._id,
                  })),
                  whatsAppMilestones:
                    findEmailMileStone?.waMilestones?.map(
                      (milestone: any) => milestone._id
                    ) || [],
                  emailMilestones:
                    findEmailMileStone?.emailMilestones?.map(
                      (milestone: any) => milestone._id
                    ) || [],

                  whatsappGroupMilestones:
                    findEmailMileStone?.whatsappGroupMilestones?.map(
                      (milestone: any) => milestone._id
                    ) || [],
                  templateName: option,
                };
              });
            }}
            styles={rsStyles}
          />
        </div>
      )}

      <Box sx={{ mb: 0 }}>
        {type === "Awb" && (
          <div className="mb-3">
            <div style={labelStyle}>
              ✈️ Tracking Number <span style={{ color: "#d92d20" }}>*</span>
            </div>
            <Select
              isMulti={false}
              isDisabled={editable}
              name="awb"
              options={subscriptionList?.map((item: any) => ({
                label: item?.oceanTrackingNumber,
                value: item.oceanTrackingNumber,
              }))}
              placeholder="Select Tracking Number"
              className="basic-multi-select"
              classNamePrefix="select"
              menuPortalTarget={document.body}
              value={subscriptionFormData.awbs}
              onChange={(option: any) => {
                getAllMileStone(option.value).then((res: any) => {
                  setSubscriptionFormData((prev: any) => {
                    return {
                      ...prev,
                      awbs: option,
                    };
                  });
                });
              }}
              styles={rsStyles}
            />
            {awbWarning ? (
              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "9px 12px",
                  border: "1px solid #f3d190",
                  background: "#fff8ec",
                  borderRadius: 8,
                  color: "#92650d",
                  fontSize: 12.5,
                  fontWeight: 600,
                }}
              >
                <span style={{ fontSize: 14, lineHeight: 1 }}>⚠️</span>
                Please select the tracking number first
              </div>
            ) : !hasAwb ? (
              <div style={{ fontSize: 11.5, color: "#5b6472", marginTop: 6 }}>
                Select a tracking number to enable milestone selection.
              </div>
            ) : null}
          </div>
        )}
      </Box>

      <div className="mb-3">
        <div style={labelStyle}>🏢 Select organization</div>
        <Select
          name="masterOrganization"
          options={subscriptionFormData?.masterContactOrgnization?.map((item: any) => ({
            label: item?.name,
            value: item?._id,
          }))}
          placeholder="Select organization"
          className="basic-multi-select"
          classNamePrefix="select"
          menuPortalTarget={document.body}
          value={subscriptionFormData?.masterOrganization}
          onChange={(option: any) => {
            const findOrganization =
              subscriptionFormData.masterContactOrgnization?.find(
                (item: any) => item?._id === option?.value
              );

            setSubscriptionFormData((prev: any) => ({
              ...prev,
              masterOrganization: option,
            }));

            getContactList(findOrganization?._id || "");
          }}
          styles={rsStyles}
        />
      </div>

      {editData?.row?.alertType === "whatsapp" ? (
        <div className="mb-3">
          <div style={labelStyle}>💬 WhatsApp</div>
          <Select
            isMulti
            name="whatsapp-users"
            options={manageContactList
              ?.filter(
                (item: any) =>
                  item.isActive && item?.whatappNumber && (item?.allowedChannels || []).includes("whatsapp")
              )
              .map((item: any) => ({
                label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.organizationName})`,
                value: item._id,
              }))}
            placeholder="Enter Users"
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            value={subscriptionFormData.whatsApp}
            onChange={(option: any) => {
              setSubscriptionFormData((prev: any) => {
                return {
                  ...prev,
                  whatsApp: option,
                };
              });
            }}
            styles={rsStyles}
          />
          <MilestoneTrigger
            mileStoneType="whatsApp"
            count={(subscriptionFormData?.whatsAppMilestones || []).length}
          />
          {errors.whatsApp && <div style={errStyle}>{errors.whatsApp}</div>}
        </div>
      ) : Object.keys(editData)?.length === 0 ? (
        <div className="mb-3">
          <div style={labelStyle}>💬 WhatsApp</div>
          <Select
            isMulti
            name="whatsapp-users"
            options={manageContactList
              ?.filter(
                (item: any) =>
                  item.isActive && item?.whatappNumber && (item?.allowedChannels || []).includes("whatsapp")
              )
              .map((item: any) => ({
                label: `${item?.salutation}. ${item?.name} (${item?.countryCode}${item?.whatappNumber}, ${item?.masterContactOrganization?.name})`,
                value: item._id,
              }))}
            placeholder="Enter Users"
            className="basic-multi-select"
            classNamePrefix="select"
            menuPortalTarget={document.body}
            value={subscriptionFormData.whatsApp}
            onChange={(option: any) => {
              setSubscriptionFormData((prev: any) => {
                return {
                  ...prev,
                  whatsApp: option,
                };
              });
            }}
            styles={rsStyles}
          />
          <MilestoneTrigger
            mileStoneType="whatsApp"
            count={(subscriptionFormData?.whatsAppMilestones || []).length}
          />
          {errors.whatsApp && <div style={errStyle}>{errors.whatsApp}</div>}
        </div>
      ) : (
        <></>
      )}

      <Box sx={{ mt: 0 }}>
        {editData?.row?.alertType === "email" ? (
          <div className="mb-3">
            <div style={labelStyle}>✉️ Email</div>
            <Select
              isMulti
              name="Email"
              placeholder="Select..."
              className="basic-multi-select"
              classNamePrefix="select"
              menuPortalTarget={document.body}
              options={manageContactList
                ?.filter(
                  (item: any) =>
                    item.isActive && item?.email && (item?.allowedChannels || []).includes("email")
                )
                .map((item: any) => ({
                  label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.masterContactOrganization?.name})`,
                  value: item._id,
                }))}
              value={subscriptionFormData.emails}
              onChange={(option: any) => {
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    emails: option,
                  };
                });
              }}
              styles={rsStyles}
            />
            <MilestoneTrigger
              mileStoneType="email"
              count={(subscriptionFormData?.emailMilestones || []).length}
            />
            {errors.emails && <div style={errStyle}>{errors.emails}</div>}
          </div>
        ) : editData && Object.keys(editData)?.length === 0 ? (
          <div className="mb-3">
            <div style={labelStyle}>✉️ Email</div>
            <Select
              isMulti
              name="Email"
              placeholder="Select..."
              className="basic-multi-select"
              classNamePrefix="select"
              menuPortalTarget={document.body}
              options={manageContactList
                ?.filter(
                  (item: any) =>
                    item.isActive && item?.email && (item?.allowedChannels || []).includes("email")
                )
                .map((item: any) => ({
                  label: `${item?.salutation}. ${item?.name} (${item?.email}, ${item?.organizationName})`,
                  value: item._id,
                }))}
              value={subscriptionFormData.emails}
              onChange={(option: any) => {
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    emails: option,
                  };
                });
              }}
              styles={rsStyles}
            />
            <MilestoneTrigger
              mileStoneType="email"
              count={(subscriptionFormData?.emailMilestones || []).length}
            />
            {errors.emails && <div style={errStyle}>{errors.emails}</div>}
          </div>
        ) : null}

        {editData?.row?.alertType === "whatsappgroup" ? (
          <div className="mb-3">
            <div style={labelStyle}>👥 WhatsApp Group</div>
            <Select
              isMulti
              name="whatsapp-group"
              options={whatsappGroupList
                ?.filter((item: any) => item?.name)
                .map((item: any) => ({
                  label: `${item?.name}`,
                  value: item._id,
                }))}
              placeholder="Enter Group"
              className="basic-multi-select"
              classNamePrefix="select"
              menuPortalTarget={document.body}
              value={subscriptionFormData.whatsAppgroups}
              onChange={(option: any) => {
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    whatsAppgroups: option,
                  };
                });
              }}
              styles={rsStyles}
            />
            <MilestoneTrigger
              mileStoneType="whatsappGroup"
              count={(subscriptionFormData?.whatsappGroupMilestones || []).length}
            />
            {errors.groups && <div style={errStyle}>{errors.groups}</div>}
          </div>
        ) : Object.keys(editData)?.length === 0 ? (
          <div className="mb-3">
            <div style={labelStyle}>👥 WhatsApp Group</div>
            <Select
              isMulti
              name="whatsapp-users"
              options={whatsappGroupList
                ?.filter((item: any) => item?.name)
                .map((item: any) => ({
                  label: `${item?.name}`,
                  value: item._id,
                }))}
              placeholder="Enter Groups"
              className="basic-multi-select"
              classNamePrefix="select"
              menuPortalTarget={document.body}
              value={subscriptionFormData.whatsAppgroups}
              onChange={(option: any) => {
                setSubscriptionFormData((prev: any) => {
                  return {
                    ...prev,
                    whatsAppgroups: option,
                  };
                });
              }}
              styles={rsStyles}
            />
            <MilestoneTrigger
              mileStoneType="whatsappGroup"
              count={(subscriptionFormData?.whatsappGroupMilestones || []).length}
            />
            {errors.groups && <div style={errStyle}>{errors.groups}</div>}
          </div>
        ) : (
          <></>
        )}

        {errors.channel && <div style={{ ...errStyle, marginBottom: 8 }}>{errors.channel}</div>}

        {type === "Awb" && (
          <Button
            className="btn btnTheme"
            variant="outlined"
            disabled={!subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0 || loading}
            onClick={handleSubmitClick}
            sx={{
              opacity: !subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0 ? 0.5 : 1,
              cursor:
                !subscriptionFormData?.awbs || subscriptionFormData?.awbs.length === 0
                  ? "not-allowed"
                  : "pointer",
              transition: "opacity 0.3s ease",
            }}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : editable ? (
              "Update"
            ) : (
              "Submit"
            )}
          </Button>
        )}
      </Box>
    </Box>
  );

};

export default OceanSubscriptionForm;
